import { TrackJS } from 'trackjs';
import { NgZone } from '@angular/core';
import { getRegion } from './environments.const';

export const trackJs = TRACKJS_APP ? TrackJS : null;

export function configTrackJs(user, zone: NgZone) {
  if (trackJs) {
    zone.runOutsideAngular(() => {
      trackJs.install({
        token: '78867b202d6d44d1a2367a8d595757d2',
        application: TRACKJS_APP,
      });
      trackJs.configure({
        userId: user.email || user.username,
      });
      trackJs.addMetadata('role', user.role);
      trackJs.addMetadata('KT Dashboard Version', CLIENT_APP_VERSION);
      trackJs.addMetadata('region', getRegion());
    });
  }
}
